<template>
  <div class="sticky-legend-compliance">
    <table class="el-table-legends table-bordered mt-4">
      <thead>
        <tr>
          <th class="col-4 py-1 th-danger">
            {{ $t('common_words.bad') }}
            <br />
            &lt; 90%
          </th>
          <th class="col-4 py-1 th-warning">
            {{ $t('common_words.regular') }}
            <br />
            90% - 95%
          </th>
          <th class="col-4 py-1 th-success">
            {{ $t('common_words.good') }}
            <br />
            &gt; 95%
          </th>
        </tr>
      </thead>
    </table>
  </div>
</template>
<script>
export default {
  name: 'sticky-legend-compliance',
};
</script>
<style>
.sticky-legend-compliance {
  position: sticky;
  top: 0;
}
.sticky-legend-compliance .el-table-legends {
  width: 100%;
  margin-bottom: 20px;
  font-size: smaller;
}
</style>
